"use client";

import { registerPlugin } from "@capacitor/core";

export type NativeLocationStatus = {
  platform: "ios" | "android";
  servicesEnabled: boolean;
  foregroundGranted: boolean;
  preciseGranted: boolean;
  backgroundGranted: boolean;
  authorizationStatus?: string;
  accuracyAuthorization?: string;
};

export type HiiveLocationPermissionsPlugin = {
  getLocationStatus(): Promise<NativeLocationStatus>;
  requestBackgroundAuthorization(): Promise<NativeLocationStatus>;
  openAppSettings(): Promise<void>;
  openNotificationSettings(): Promise<void>;
};

export const HiiveLocationPermissions =
  registerPlugin<HiiveLocationPermissionsPlugin>("HiiveLocationPermissions");
